import clsx from "clsx";

import type { ReactNode } from "react";

export default function SectionContainer({
  title,
  children,
  isColumn,
  hasBorder,
  titleComponent,
}: {
  title: string;
  children: ReactNode;
  isColumn: boolean;
  hasBorder: boolean;
  titleComponent?: JSX.Element;
}) {
  return (
    <div
      className={clsx(
        "flex px-4",
        isColumn
          ? "flex-col gap-y-2.5 pb-2 pt-2.5"
          : "py-2 gap-x-2.5 justify-between items-center",
        hasBorder && "border-b border-b-black-200",
      )}
    >
      <div className="flex justify-between items-center">
        <span className="text-button-sm">{title}</span>
        {titleComponent}
      </div>

      {children}
    </div>
  );
}
